import { useCallback, useEffect, useState } from "react";

/* ============================================================================
   SISTEMA-DE-DISENO · densidad de tablas, preferencia POR USUARIO.

   Vive en localStorage y se estampa como `data-densidad` en <html>. Ninguna
   pantalla la recibe ni la reenvía: la densidad se aplica redefiniendo dos
   tokens (`--h-row`, `--h-table-head`), que es de donde ya salen las alturas
   de toda tabla del sistema. Cambiarla no vuelve a consultar nada.

   Es una preferencia de quien mira, no un dato de la clínica: no se guarda en
   el servidor y no viaja entre usuarios.
   ========================================================================== */

export const DENSIDAD_STORAGE_KEY = "smartmedic.densidad";
export const DENSIDAD_NORMAL = "normal";
export const DENSIDAD_COMPACTA = "compacta";

export function normalizarDensidad(valor) {
    return valor === DENSIDAD_COMPACTA ? DENSIDAD_COMPACTA : DENSIDAD_NORMAL;
}

export function leerDensidad() {
    try {
        if (typeof window === "undefined" || !window.localStorage) return DENSIDAD_NORMAL;
        return normalizarDensidad(window.localStorage.getItem(DENSIDAD_STORAGE_KEY));
    } catch (e) {
        return DENSIDAD_NORMAL;
    }
}

export function aplicarDensidad(valor) {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("data-densidad", normalizarDensidad(valor));
}

export default function useDensidad() {
    const [densidad, setDensidadEstado] = useState(leerDensidad);

    useEffect(() => {
        aplicarDensidad(densidad);
    }, [densidad]);

    const setDensidad = useCallback((valor) => {
        const seguro = normalizarDensidad(valor);
        try {
            if (typeof window !== "undefined" && window.localStorage) {
                window.localStorage.setItem(DENSIDAD_STORAGE_KEY, seguro);
            }
        } catch (e) {
            // Sin localStorage la preferencia dura lo que dure la sesión.
        }
        setDensidadEstado(seguro);
    }, []);

    return { densidad, setDensidad };
}
